import { render, staticRenderFns } from "./holidaysummarytable.vue?vue&type=template&id=5bb6eea0&"
import script from "./holidaysummarytable.vue?vue&type=script&lang=js&"
export * from "./holidaysummarytable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports